define.alias("shared/components/shared/social/instagram-modal/unavailable-page", "settings/components/shared/social/instagram-modal/unavailable-page");